import { render, staticRenderFns } from "./MenuLinksMod.vue?vue&type=template&id=23d3d99f"
import script from "./MenuLinksMod.vue?vue&type=script&lang=js"
export * from "./MenuLinksMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports